import { Producer } from 'types/producer'
import type { OverviewStepProps } from 'features/registration/steps/types'
import { CmsReferralAction } from 'types/cms/collection-types'
import { PropositionState } from 'store/customer/types'
import { CounterType, Region } from '@boltenergy-be/shared'

// COMPONENT PROPS

export type RegistrationProps = {
  hideHeader?: boolean
  producer: Producer
  activeAction?: CmsReferralAction
} & Pick<OverviewStepProps, 'overrideNextStep'>

// ENUMS

export enum RegistrationSteps {
  DELIVERY_ADDRESS = 'Delivery Address',
  PERSONAL_DATA = 'Personal Data',
  METER_DETAILS = 'Meter Details',
  BILLING = 'Billing',
  OVERVIEW = 'Overview',
  CONFIRMATION = 'Confirmation'
}

// TYPES

export type CreditCheck = {
  executed: boolean
  accepted?: boolean
}

export type Month = {
  i18nKey: string
  defaultValue: string
}

export type StartDateRange = {
  min: string // ISO
  max: string // ISO
  initial: string // ISO
}

export type CheckIsDynamicTariffEligible = {
  proposition: PropositionState['selectedProposition']
  counterType: CounterType
  region: Region
  hasExclusiveNightMeter: boolean
}

export type CheckSettlementFrequencyEligible = {
  eventID?: string
  counterType: CounterType
  region: Region
}
